import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import {
	TIRESIAS_DOMAINS,
	initializeFeatbitProviders,
	useTiresiasIdentity
} from 'afrodita/src/features';
import env from '../environment';

const ANONYMOUS_KEY_ID = 'anonymous';
const MANAGEMENT_CODE = 'gibobs';

// The auth reducer starts with an empty profile after a reload, so fall back to the one in localStorage.
const getStoredProfile = () => {
	try {
		return JSON.parse(localStorage.getItem('profile') || '{}');
	} catch {
		return {};
	}
};

export function FeatureFlagsProvider({ children }) {
	const reduxProfile = useSelector((state) => state.auth.profile);
	const profile = reduxProfile?.id ? reduxProfile : getStoredProfile();

	// Without a logged-in user the identity is anonymous and flags target by managementCode, as in the calculator.
	// Declared before the initialisation effect so the first FeatBit identify already carries it.
	useTiresiasIdentity({
		keyId: profile?.id ? String(profile.id) : ANONYMOUS_KEY_ID,
		name: profile?.name,
		managementCode: MANAGEMENT_CODE
	});

	useEffect(() => {
		// Fire-and-forget: flags fall back to their defaults until the providers are ready.
		// Config comes from env.*.json because Jenkins builds cannot inject environment variables.
		initializeFeatbitProviders(env.tiresias);
	}, []);

	return <OpenFeatureProvider domain={TIRESIAS_DOMAINS.base}>{children}</OpenFeatureProvider>;
}
